import { countriesList } from '../components/CountrySelector/list';
import { Currency } from '../entities/Currency';
import { RateJSON } from '../entities/Rate';

export interface CurrencyConversion {
  source: Currency;
  target: Currency;
  rate: Omit<RateJSON, 'date'>;
}

const countriesCurrenciesMap: Map<string, Currency | null> = new Map(countriesList.map(({ value, currency }) => [value, currency]));

export function getCurrencyByCountryCode(countryCode: string): Currency | null {
  const currency = countriesCurrenciesMap.get(countryCode.toUpperCase());

  return currency ? currency : null;
}